(function runIntelligemsCart() {
  function serializeCart(cart) {
    return cart.items
      .map(function (i) {
        return i.key + ":" + i.quantity;
      })
      .sort()
      .join(",");
  }
  subscribe(PUB_SUB_EVENTS.cartRender, function (event) {
    // The cart has re-rendered. Fetch the cart again to
    // trigger an IG update.
    fetch("/cart.js");
  });
  window.addEventListener("ig:CartUpdated", () => {
    window.BIRTHDATE_CART.refreshCart();
  })
  fetch('/cart.js');

  function addStylesForGWP() {
    const gwpCampaigns = igData.campaigns.getGWP();
    if (!gwpCampaigns.length) {
      return;
    }
    // If there are any GWP campaigns, hide the cart upsell
    const style = document.createElement("style");
    style.innerHTML =
      "ig-volume-progress-bar-widget + .cart-drawer__upsell-container { display: none; }";
    document.head.appendChild(style);
  }

  function handleIgMessageForGWP(event) {
    if (event.data === "ig-ready") {
      window.removeEventListener("message", handleIgMessageForGWP);
      addStylesForGWP();
    }
  }
  if (window._INTELLIGEMS_READY) {
    addStylesForGWP();
  } else {
    window.addEventListener("message", handleIgMessageForGWP);
  }
})();
